import { type FC } from "react";
import { TriggerArrowDown } from "../../Link/Trigger";

interface LoadMoreButtonProps {
	getMoreTransactions: () => void;
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({
	getMoreTransactions,
}) => {
	return (
		<TriggerArrowDown onClick={getMoreTransactions} sx={{ py: 4 }}>
			Starší pohyby
		</TriggerArrowDown>
	);
};

export default LoadMoreButton;
